<section class="topic" [attr.data-testid]="testId">
  @if (violations !== null) {
    <section class="source-records" data-testid="in-prison-violation-list" aria-label="Recorded rules violations">
      <h3 [appTerminologyIdentity]="terminologyUsage.violations">{{ text.violations() }}</h3>
      <p class="field-help">Recorded rules violations from the case record.</p>
      <ui-grid width="fill" containerClass="no-panel" [rowData]="violations" [columnDefs]="columns()"
        [defaultColDef]="columnDefaults" [agGridOptions]="gridOptions" [showPanelHeader]="false"
        [autoHidePaginator]="true" [rowHeight]="40" noRowsHeight="180px"
        noDataFoundMessage="No in-prison violations are on record."></ui-grid>
    </section>
  }
  <section aria-label="Panel observations">
    <h3>Panel observations</h3>
    <div class="narratives">
      @for (group of groups; track group.testId) {
        <section class="narrative" [attr.data-testid]="group.testId" [attr.aria-label]="group.title">
          <ui-form [config]="group.config" [appTerminologyFormIdentity]="formUsage" [formValues]="values()"
            [disabled]="!canEdit()" (inputChange)="onInputChange($event)"></ui-form>
          @if (group.description) { <p class="field-help">{{ group.description }}</p> }
        </section>
      }
    </div>
  </section>
</section>
